import { updateObject } from 'store/utility';
import {
    HIDE_SPINNER,
    RESET_AGREEMENTS,
    TOGGLE_SPINNER,
    GET_V2_PROVIDER_SUMMARY,
    GET_V2_SHARING_AGREEMENTS,
    UPDATE_V2_SHARING_AGREEMENT,
    ADD_V2_SHARING_AGREEMENT,
    GET_V2_PROVIDER_CONFIG
} from '../actions/types';
import {
    GET_V2_CONNECTION_AGREEMENTS,
    RESET_SEARCH_TEXT,
    DISCARD_CHANGES,
    IS_TITAN_SERVICE_ENABLED,
    SET_CLOUD_HUB_CONNECTOR_STATUS,
    SET_CLOUD_HUB_CONNECTOR_STATUS_ERROR,
    FETCH_CLOUD_HUB_CONNECTOR_STATUS,
    ADD_PROVIDER_ID,
    SET_SELECTED_V2_SHARING_AGREEMENT
} from '../actions/types';
import { normalizeDeliverToOtherParties } from '../utils/agreementV2Normalization';

const initialState = {
    agreementV2List: [],
    totalElements: 0,
    page: 1,
    pageSize: 10,
    isTitanServiceEnabled: false,
    isAgreementInEditMode: false,
    groupToOpen: '',
    selectedVisibilityProvider: {
        name: '',
        id: ''
    },
    existingAgreementGroup: {},
    currentGroup: {},
    disableOtherOperation: false,
    showSpinner: true,
    searchText: '',
    providerSummary: [],
    sharingAgreements: [],
    providerConfig: [],
    isCloudHubConnectorActive: false,
    isCloudHubConnectorStatusLoaded: false,
    isCloudHubConnectorStatusError: false,
    providerId: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_V2_CONNECTION_AGREEMENTS:
            return updateObject(state, {
                agreementV2List: (action.payload ?? []).map((a) => ({
                    ...a,
                    deliverToOtherParties: normalizeDeliverToOtherParties(a.deliverToOtherParties)
                }))
            });
        case TOGGLE_SPINNER:
            return updateObject(state, { showSpinner: true });
        case HIDE_SPINNER:
            return updateObject(state, { showSpinner: false });
        case RESET_SEARCH_TEXT:
            return updateObject(state, {
                searchText: ''
            });
        case RESET_AGREEMENTS:
            return updateObject(state, { agreementV2List: [] });
        case DISCARD_CHANGES:
            return { ...state, discardChanges: action.payload };
        case IS_TITAN_SERVICE_ENABLED:
            return {
                ...state,
                isTitanServiceEnabled: action.payload
            };
        case FETCH_CLOUD_HUB_CONNECTOR_STATUS:
            return {
                ...state,
                isCloudHubConnectorActive: false,
                isCloudHubConnectorStatusLoaded: false,
                isCloudHubConnectorStatusError: false
            };
        case SET_CLOUD_HUB_CONNECTOR_STATUS:
            return {
                ...state,
                isCloudHubConnectorActive: action.payload,
                isCloudHubConnectorStatusLoaded: true,
                isCloudHubConnectorStatusError: false
            };
        case SET_CLOUD_HUB_CONNECTOR_STATUS_ERROR:
            return {
                ...state,
                isCloudHubConnectorActive: false,
                isCloudHubConnectorStatusLoaded: false,
                isCloudHubConnectorStatusError: true
            };
        case GET_V2_SHARING_AGREEMENTS:
            return {
                ...state,
                sharingAgreements: (action.payload ?? []).map((a) => ({
                    ...a,
                    deliverToOtherParties: normalizeDeliverToOtherParties(a.deliverToOtherParties)
                })),
                page: action.page,
                totalElements: action.totalElement,
                pageSize: action.size
            };
        case GET_V2_PROVIDER_SUMMARY:
            return {
                ...state,
                providerSummary: action.payload,
                page: action.page,
                totalElements: action.totalElement,
                pageSize: action.size
            };
        case GET_V2_PROVIDER_CONFIG:
            return {
                ...state,
                providerConfig: action.payload
            };
        case UPDATE_V2_SHARING_AGREEMENT:
            return {
                ...state,
                sharingAgreements: state.sharingAgreements.map((agreement) =>
                    agreement.id === action.payload.id ? action.payload : agreement
                )
            };
        case ADD_V2_SHARING_AGREEMENT:
            return {
                ...state,
                sharingAgreements: [...state.sharingAgreements, action.payload]
            };
        case ADD_PROVIDER_ID:
            return { ...state, providerId: action.payload };
        case SET_SELECTED_V2_SHARING_AGREEMENT:
            return { ...state, selectedV2SharingAgreement: action.payload };
        default:
            return state;
    }
};
